"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("@mui/material"),e=require("@mui/material/styles"),o=e.styled("div")`
  display: flex;
  width: 264px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`,n=e.styled(i.Typography)(({theme:t})=>({color:t.palette.grey[800]})),r=e.styled(i.TextField)(({theme:t})=>({"&& .MuiInputBase-root":{margin:"12px 0",padding:"8px",minWidth:"240px",height:"120px",boxSizing:"border-box",background:t.palette.grey[50],"&:hover":{background:t.palette.grey[50]}},"&& .MuiInputBase-input":{margin:"12px 0",minWidth:"240px",height:"120px",boxSizing:"border-box"}})),l=e.styled("div")`
  align-self: flex-end;
  display: flex;
  gap: 8px;
`,d=e.styled("form")`
  display: flex;
  gap: 12px;
  flex-direction: column;
  width: 100%;
`;exports.CommentField=r;exports.Container=o;exports.Footer=l;exports.FormContainer=d;exports.Title=n;
